// src/app/index.jsx
import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { FaCalendar, FaUsers, FaBriefcase, FaDollarSign, FaFileAlt, FaCog } from 'react-icons/fa';

export default function HomeScreen() {
  const navigate = useNavigate();
  const [userPermissions, setUserPermissions] = useState(null);

  // Load user permissions on component mount
  useEffect(() => {
    const loadUserPermissions = async () => {
      try {
        const permissions = localStorage.getItem('userPermissions');
        if (permissions) {
          setUserPermissions(JSON.parse(permissions));
        }
      } catch (error) {
        console.error('Error loading user permissions:', error);
      }
    };
    loadUserPermissions();
  }, []);

  // Check if user has job permissions
  const hasJobPermissions = () => {
    return userPermissions?.job_perm !== 'none';
  };

  // Check if user has customer permissions
  const hasCustomerPermissions = () => {
    return userPermissions?.customer_perm !== 'none';
  };

  // Check if user has invoice permissions
  const hasInvoicePermissions = () => {
    return userPermissions?.invoice_perm !== 'none';
  };

  // Check if user has quote permissions
  const hasQuotePermissions = () => {
    return userPermissions?.quote_perm !== 'none';
  };

  // Handle navigation with permission check for job-related pages
  const handleSchedulePress = () => {
    if (!hasJobPermissions()) {
      alert("You don't have permission to view jobs. Please contact your account administrator.");
      return;
    }
    navigate('/schedule');
  };

  const handleJobsPress = () => {
    if (!hasJobPermissions()) {
      alert("You don't have permission to view jobs. Please contact your account administrator.");
      return;
    }
    navigate('/jobs');
  };

  // Handle navigation with permission check for customer-related pages
  const handleCustomersPress = () => {
    if (!hasCustomerPermissions()) {
      alert("You don't have permission to view customers. Please contact your account administrator.");
      return;
    }
    navigate('/view-customers');
  };

  // Handle navigation with permission check for invoice-related pages
  const handleInvoicesPress = () => {
    if (!hasInvoicePermissions()) {
      alert("You don't have permission to view invoices. Please contact your account administrator.");
      return;
    }
    navigate('/invoices');
  };

  // Handle navigation with permission check for quote-related pages
  const handleQuotesPress = () => {
    if (!hasQuotePermissions()) {
      alert("You don't have permission to view quotes. Please contact your account administrator.");
      return;
    }
    navigate('/quotes');
  };

  return (
    <View style={styles.container}>
      <Text style={styles.header}>My Dashboard</Text>

      <View style={styles.rowContainer}>
        <TouchableOpacity style={styles.iconButton} onPress={handleSchedulePress}>
          <FaCalendar size={50} color="#fff" aria-hidden />
          <Text style={styles.iconButtonText}>Schedule</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.iconButton} onPress={handleCustomersPress}>
          <FaUsers size={50} color="#fff" aria-hidden />
          <Text style={styles.iconButtonText}>Customers</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.rowContainer}>
        <TouchableOpacity style={styles.iconButton} onPress={handleJobsPress}>
          <FaBriefcase size={50} color="#fff" aria-hidden />
          <Text style={styles.iconButtonText}>Jobs</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.iconButton} onPress={handleInvoicesPress}>
          <FaDollarSign size={50} color="#fff" aria-hidden />
          <Text style={styles.iconButtonText}>Invoices</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.rowContainer}>
        <TouchableOpacity style={styles.iconButton} onPress={handleQuotesPress}>
          <FaFileAlt size={50} color="#fff" aria-hidden />
          <Text style={styles.iconButtonText}>Quotes</Text>
        </TouchableOpacity>

        <TouchableOpacity style={styles.iconButton} onPress={() => navigate('/settings')}>
          <FaCog size={50} color="#fff" aria-hidden />
          <Text style={styles.iconButtonText}>Settings</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { minHeight: '100vh', width: '100%', paddingHorizontal: 10, paddingTop: '5%', alignItems: 'center', backgroundColor: '#fff' },
  header: { fontSize: 26, fontWeight: 'bold', marginBottom: 30, color: '#003366', textDecorationLine: 'underline' },
  rowContainer: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 40, marginTop: 10 },
  iconButton: { backgroundColor: '#007BFF', padding: 20, marginHorizontal: 25, borderRadius: 8, width: 120, height: 120, justifyContent: 'center', alignItems: 'center', cursor: 'pointer', outlineStyle: 'none' },
  iconButtonText: { color: '#fff', fontSize: 16, marginTop: 10, textAlign: 'center' },
});
